module.exports = __webpack_public_path__ + "img/Wp_2041.7d6b9e3b.png";